import { motion } from "framer-motion";
import { useState } from "react";

// Import images (assuming you will place them in /public or /assets and update the paths accordingly)
const toolImages = [
  require("../assets/tool1.jpeg"), // Arrowin Shutter Tester EF-8000
  require("../assets/tool2.jpeg"), // Colour Viewer (5100K)
  require("../assets/tool3.jpeg"), // Pattern Box (3100K)
  require("../assets/tool4.jpeg"), // Collimators – 300mm & 600mm (for SLR cameras)
  require("../assets/tool5.jpeg"), // Digital Power Regulators
];

const toolNames = [
  "Arrowin Shutter Tester EF-8000",
  "Colour Viewer (5100K)",
  "Pattern Box (3100K)",
  "Collimators – 300mm & 600mm (for SLR cameras)",
  "Digital Power Regulators",
  "Dial Gauge",
  "Flash Meter",
  "LV Measurement Unit BM 3000",
  "AE & AF Adjustment Tools",
  "CCD Tester",
  "Rework Station",
  "Mirror Angle Tool",
  "Digital Oscilloscope",
  "Optical Axis Tool",
  "Communication Tool",
  "Electronic Microscope",
  "Pulse Counter for Lens Testing",
  "Lens Talk",
  "FX40 Slant Chart",
  "Image Stability Testing Tools",
];

const tools = toolNames.map((name, idx) => ({
  name,
  image: toolImages[idx] || null,
}));

const Products = () => {
  return (
    <div className="container py-20">
      {/* Header Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-16"
      >
        <h1 className="text-4xl font-bold mb-6">Adjustment Tools</h1>
        <div className="max-w-4xl mx-auto space-y-6">
          <p className="text-lg text-muted-foreground">
            We are the only authorised service centre in Tamil Nadu, and hence
            only we are permitted to perform adjustments related to exposure,
            focusing, flash volume, and white balance. These procedures involve
            rewriting critical data such as flash RAM, EEPROM, and colour
            calibration data on the board.
          </p>
          <p className="text-lg text-muted-foreground">
            We also handle precise adjustments of the main mirror, sub mirror,
            and autofocus sensor, including AF sensor position, 1m and infinity
            focus data, flash volume settings, and auto exposure sensor
            calibration.
          </p>
          <p className="text-lg font-semibold">
            We use the following advanced equipment for precise calibration and
            adjustment, in accordance with industry standards:
          </p>
        </div>
      </motion.div>

      {/* Tools Grid */}

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {tools.map((tool, index) => (
          <motion.div
            key={tool.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="group relative bg-background rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow p-6 flex flex-col items-center"
          >
            <h3 className="text-xl font-bold text-center mb-2">{tool.name}</h3>
          </motion.div>
        ))}
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {toolImages.map((tool, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="group relative bg-background rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow p-6 flex flex-col items-center"
          >
            <img
              src={tool}
              alt={index}
              className="w-full h-56 object-contain mb-4 rounded"
            />
          </motion.div>
        ))}
      </div>
      <p className="text-center text-muted-foreground mt-12 text-lg">
        These specialized tools ensure high-precision service quality for
        professional-grade camera and lens servicing.
      </p>
      <div className="mt-12 flex justify-center">
        <img
          src={require("../assets/tools_desc.jpeg")}
          alt="Tools Description"
          className="max-w-full h-auto rounded-lg shadow-md"
        />
      </div>
    </div>
  );
};

export default Products;
